import { AgCharts } from "ag-charts-react";

// const data = [
//   {
//     quarter: "Cocody",
//     iphone: 140,
//     mac: 16,
//   },
//   {
//     quarter: "Plateau",
//     iphone: 124,
//     mac: 20,
//   },
//   {
//     quarter: "Adjame",
//     iphone: 112,
//     mac: 20,
//   },
//   {
//     quarter: "Yopougon",
//     iphone: 118,
//     mac: 24,
//   },
//   {
//     quarter: "Abobo",
//     iphone: 400,
//     mac: 24,
//   },
// ];

const HorizontalBarChart = (props:any) => {
  const {report, title} = props;
  const data = report?.top_10_areas_collected_and_pending_amount
  // console.log(report)
  
  const options: any = {
    title: {
      // make title text of the option bold
      fontWeight: "bold",
      text: title || "Top 5 des meilleurs recouvrements",
    },
    subtitle: {
      text: "",
    },
    data: data,
    height:400,
    series: [
      {
        type: "bar",
        direction: "horizontal",
        xKey: "area",
        yKey: "collected_amount",
        yName: "Montant collecté",
        fill: "#e33621",
        cornerRadius: 3,
        fillOpacity: "#e33621",
      },
      {
        type: "bar",
        direction: "horizontal",
        xKey: "area",
        yKey: "pending_amount",
        yName: "Montant attendu",
        cornerRadius: 3,
        fill: "#e5e6eb",
        fillOpacity: "#e5e6eb",
      },
    ],
  };

  return <AgCharts options={options} />;
};

export default HorizontalBarChart;
